// const PARSED_DATA_EXAMPLE = [
//      'hotels',
//      'restaurants'
// ];

export const parse = rawData => rawData.map(item => item.kw);
